export const PAGE_SIZE = 20;
export const SORT_ORDER_DESC = 'desc';
export const SORT_ORDER_ASC = 'asc';
export const SELECTION = 'selection';
